/**
 * Conscious alerts SSE — AppTopBar badge 등 경량 구독 (shared EventSource)
 */

import { useCallback, useEffect, useState } from 'react';
import { useTenant } from '../../contexts/TenantContext';
import {
  subscribeConsciousAlertsSse,
  type ConsciousAlertsSsePayload,
} from '../../services/consciousAlertsSseClient';

function resolveAlertCount(payload: ConsciousAlertsSsePayload): number {
  if (typeof payload.count === 'number') return payload.count;
  if (Array.isArray(payload.alerts)) return payload.alerts.length;
  return 0;
}

export function useConsciousAlertsSse(): { alertCount: number; refresh: () => void } {
  const { currentTenant } = useTenant();
  const tenantId = currentTenant?.id ?? 'default_tenant';
  const [alertCount, setAlertCount] = useState(0);
  const [refreshToken, setRefreshToken] = useState(0);

  const refresh = useCallback(() => {
    setRefreshToken((n) => n + 1);
  }, []);

  useEffect(() => {
    const unsubscribe = subscribeConsciousAlertsSse(tenantId, (payload) => {
      setAlertCount(resolveAlertCount(payload));
    });
    return unsubscribe;
  }, [tenantId, refreshToken]);

  return { alertCount, refresh };
}
